import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import { animatePreloader } from './preloader'

const app = new modular({
    modules: modules
});

window.onload = (event) => {
    const $style = document.getElementById('main-css');

    if ($style) {
        if ($style.isLoaded) {
            init();
        } else {
            $style.addEventListener('load', (event) => {
                init();
            });
        }
    } else {
        console.warn('The "main-css" stylesheet not found');
    }
};



function init() {
    html.classList.remove('has-no-js');

    globals();

    app.init(app);

    window.preloaderEnterPromise.then(() => {
        animatePreloader();
    })

    window.preloaderPromise.then(() => {
        html.classList.add('is-loaded');
        html.classList.add('is-ready');
        html.classList.remove('is-first-loading');
        html.classList.remove('is-loading');
    })
}

